import React, { Component } from 'react';
import { connect } from 'react-redux';
import SecondStep from './SecondStep';
import ThirdStep from './ThirdStep';
import FirstStep from './FirstStep';
import { FadeLoader } from 'react-spinners';
import Modal from '../../../../../components/Modal';
import Steps from '../../../../../components/Steps';
import Alert from '../../../../../components/Alert';
import addBonoProforma from '../../../../../utils/addBonoProforma';
import addBonoPedidos from '../../../../../utils/addBonoPedidos';
import addBonosVale from '../../../../../utils/addBonosVale';
import getBonos from '../../../../../utils/getBonos';
import {fetchColaboradores,clearColaboradores} from '../../../../../actions';

class AgregarBonos extends Component {
  constructor(props) {
    super(props);

    let newArrayPedidos=[];
      newArrayPedidos = this.props.pedidos;
    this.state = {
      step: 1,
      itemsBono:0,
      listaItemsBonos:[],
      listaItemsBonosValue:{},
      listaPedido:newArrayPedidos,
      alertSuccessOpenBono:false,
      colaboradoresSeleccionados: [],
      listaPedidosSeleccionados:[],
      countContactos:1,
      bonoProforma:0,
      bonoCortesia:0,
      montoBonoProforma:0,
      totalMontoBonoProforma:0,
      codFiveBono:'',
      bonoObservaciones:'',
      codMonedaBono:props.codMonedaBono,//Req. 92293 ebarboza 26 07 2021
      muestraLoad:'none',
      listaBonos: [{
        'profroma':this.props.profroma,
        'bonoMonto':[]
      }],
      listaBonosAll:[],
      arrayAsignarBonos:this.props.arrayAsignarBonos
    };
  }


  componentDidMount() {

    this.setState({
      codMonedaBono:this.props.codMonedaBono,
      montoBonoProforma:this.props.montoBonoProforma
    });

    this.initializeVarables();

  }

  onChangeMontoCortesia = (e,codFiveBono) =>{
    if(codFiveBono===undefined){
      this.setState({ montoBonoProforma:e.target.value});
    }else{
      this.setState({ listaBonosAll: this.state.listaBonosAll.map(entry => entry.codFiveBono===codFiveBono?Object.assign({}, entry,{montoBonoProforma:e.target.value}):entry) });
    }

  }



  initializeVarables = () => {


    this.setState({
      totalMontoBonoProforma:0,
      listaPedidosSeleccionados:[],
      listaBonos: [{
        'profroma':this.props.profroma,
        'bonoMonto':[]
      }],
      colaboradoresSeleccionados: [],
      bonoObservaciones:'',
      step:1
    });

    if(this.props.callFromTabFacturacion===1){
      this.props.renderLoad();
    }
  }

  removeColaborador = (id) => {
    const { colaboradoresSeleccionados } = this.state;
    this.setState({ colaboradoresSeleccionados: colaboradoresSeleccionados.filter(colaborador => id !== colaborador.id) });
  }

  onClicRegistrarProforma =(flagBonos,ArrayPedidos,fiveBono) =>{

    let newArraylistaPedidosSeleccionados=[];
    if(this.props.flagActionTab === 'dropdown'){
      newArraylistaPedidosSeleccionados = this.state.arrayAsignarBonos;
    }else{
      newArraylistaPedidosSeleccionados = this.state.listaPedidosSeleccionados;
    }

    this.setState({muestraLoad:'block'});
    const codigosDeColor = [];
    const valueFlagBono = this.props.flagBonos === 'AgregarBonos'?'P':'C';
    this.state.colaboradoresSeleccionados.map(Rows => (
      codigosDeColor.push(Rows.id)
    ));


    Promise.all([addBonoProforma(
      this.props.fdvID,
      this.props.profroma,
      codigosDeColor,
      valueFlagBono,
      this.state.codMonedaBono,
      fiveBono===undefined?this.state.totalMontoBonoProforma:fiveBono.totalMontoBonoProforma,
      this.state.bonoObservaciones,

    )]).then((results) => {
      // ingreso de pedidos
      newArraylistaPedidosSeleccionados.forEach((items)=>{


     let pedido={}
     if(fiveBono===undefined){
       pedido = ArrayPedidos.filter(pedido=> pedido.numPedidoVeh === items)[0]
     }else{
       pedido = ArrayPedidos.filter(pedido=> pedido.numPedidoVeh === items)[0]
     }
     addBonoPedidos(
         this.props.fdvID,
         this.props.profroma,
         pedido.numPedidoVeh,
         results[0].data.codigo,
         pedido.codProv,
         pedido.codCia,
       ).then((pedidoResult)=>{
        console.log(pedidoResult);
       });

    });


       this.getCliente(this.props.profroma,fiveBono===undefined?undefined:fiveBono.codFiveBono).bonoMonto.forEach((bono,id)=>{
          addBonosVale(
            this.props.fdvID,
            this.props.profroma,
            newArraylistaPedidosSeleccionados.toString(),
            results[0].data.codigo,
            bono.value,
            bono.monto,
            bono.value*bono.monto,
            'P',
            this.state.bonoObservaciones,
            codigosDeColor,
          ).then((resultBonosVale) =>{
            console.log(resultBonosVale);
            if(this.props.flagActionTab === 'tab'){
              this.setState({muestraLoad:'none'});
              this.props.closeModal();
              this.initializeVarables();
            }
          });
     });

    });
    this.setState({listaPedidosSeleccionados:[]});
    this.setState({muestraLoad:'none'});
    this.props.closeModal();
  }




  changeColaborador = (e) => {
    this.onChangeValue(e);
    if (e.target.value.length >= 2) {
      this.props.fetchColaboradores(e.target.value);
    } else if (e.target.value.length === 0) {
      this.props.clearColaboradores();
    }
  }

  onChangeValue = e => {
      this.setState({ [e.target.name]: e.target.value })
  }

  nexCortesia = () => {
    this.setState({ step: this.state.step + 1 })
    this.props.changeFlagBonos('AgregarCortesia');

  }
  previousStep = () => {
     this.setState({ step: this.state.step - 1 })
      if(this.state.step - 1 ===1){
        this.setState({arrayAsignarBonos:this.props.arrayAsignarBonos})
      }
    }






  nextStep = () => {

    let listaBonos = [];
    let montoTotalBono = [];
    let bonoMonto = {};
    let listaBonosAll = [];

    this.setState({ step: this.state.step + 1 })

    if(( this.state.step + 1 )===2){

      if (this.props.pedidosToEdit.length>0){

        [...new Set(this.props.pedidosToEditCodFiv.map(entry => {return entry.codFiveBono}))].forEach(element => {

          listaBonos = this.props.listaBonosXproforma.filter(entry => entry.codFiveBono===element);
          montoTotalBono = this.props.listaBonosXproforma.filter(entry => entry.codFiveBono===element)[0].montoTotalBono;
          bonoMonto=listaBonos.map((entry,index) => {
            console.log(entry);
            return {
            'id':index,
            'monto':entry.montoVale,
            'value':entry.canValeBono,
            'montoBonoProforma':entry.montoBonoProforma
          }})
          listaBonos = this.state.listaBonos;
          listaBonos[0].bonoMonto=bonoMonto;



          listaBonosAll=[...listaBonosAll,{listaBonos,montoBonoProforma:montoTotalBono,totalMontoBonoProforma:montoTotalBono,codFiveBono:element}]

        })

        this.setState({
          listaBonos:listaBonos,
          montoBonoProforma:montoTotalBono,
          totalMontoBonoProforma:montoTotalBono,
          listaBonosAll:listaBonosAll
        });
      }
    }

  }



  nexBonos = () =>{

    this.props.changeFlagBonos('AgregarBonos');

    this.setState({ step: this.state.step + 1 })

      getBonos(this.props.profroma,this.props.profroma).then((result) => {
        if(result.data.bonoProforma.length>0){
          this.setState({montoBonoProforma:result.data.bonoProforma[0].valorTotalBono,
          codMonedaBono: result.data.bonoProforma[0].codMonedaEquipoLocal,
          alertSuccessOpenBono:false
        });
        }else{
          this.setState({alertSuccessOpenBono:true});
        }
      });

      this.setState({
        arrayAsignarBonos:this.state.arrayAsignarBonos.filter(entry => !this.props.listaPedidosXProforma.filter(result => !(this.props.listaBonosXproformaEstados.indexOf(result.codFiveBono)>=0)).map(pedido => {return pedido.numPedidoVeh}).indexOf(entry)>0),
        listaPedidosSeleccionados:this.state.arrayAsignarBonos.filter(entry => !this.props.listaPedidosXProforma.filter(result => !(this.props.listaBonosXproformaEstados.indexOf(result.codFiveBono)>=0)).map(pedido => {return pedido.numPedidoVeh}).indexOf(entry)>0)
      })
  }





  selectColaborador = (key) => {
    const colaboradorSelected = this.state.colaboradoresSeleccionados.filter(colaborador => colaborador.id === key).length;

    if (!colaboradorSelected) {
      const nombres = this.props.colaboradores
        .filter(({ idUsuario }) => idUsuario.toString() === key)[0].nombre;
      const apellidos = this.props.colaboradores
        .filter(({ idUsuario }) => idUsuario.toString() === key)[0].apellidos;
      const colaborador = { id: key, nombres: `${apellidos} ${nombres}` };
      this.setState({ colaborador: '', colaboradoresSeleccionados: [...this.state.colaboradoresSeleccionados, colaborador] });
      this.props.clearColaboradores();
    }
  }





  getCliente = (profroma,codFiveBono) =>{

    if(codFiveBono===undefined){
      return this.state.listaBonos.find(z=>z.profroma===profroma);
    }else{
      console.log('logger',this.state.listaBonosAll.find(z=>z.codFiveBono===codFiveBono));
      return this.state.listaBonosAll.find(z=>z.codFiveBono===codFiveBono);
    }

  }

  removeItems = (items) =>{

    if(!(this.state.listaPedidosSeleccionados.indexOf(items)>=0)){
      this.setState({listaPedido:this.state.listaPedido.filter(x => x.numPedidoVeh !== items),
        listaPedidosSeleccionados:[...this.state.listaPedidosSeleccionados,items]});
    }
  }

  removeCheckItems = (items) => {
    this.setState({listaPedidosSeleccionados:this.state.listaPedidosSeleccionados.filter(x => x !== items)});

  }

  addItemsBonos= (profroma, codFiveBono) =>  {

    let listaBonos =  this.state.listaBonos;

    if(codFiveBono!==undefined){
      listaBonos = this.state.listaBonosAll;
      listaBonos.forEach(entry => {
        if(entry.codFiveBono===codFiveBono){
          entry.bonoMonto=[...entry.bonoMonto, { 'id': entry.bonoMonto.length>0?Math.max(...entry.bonoMonto.map(array => {return array.id})) + 1:0, 'value': '1', 'monto': '' }]
        }
      })
      this.setState({listaBonos:listaBonos})

    }else{
      listaBonos =  this.state.listaBonos;

      this.setState({ listaBonos: listaBonos.map(z => z.profroma === profroma ? Object.assign({}, z, { 'bonoMonto': [...z.bonoMonto, {  'id': this.state.countContactos++, 'value': '1', 'monto': '' }] }) : z),countContactos:this.state.countContactos++ });
    }

  }

  removeBono = (e,id,profroma,codFiveBono) => {
    if(codFiveBono===undefined){
      this.setState({ listaBonos: this.state.listaBonos.map(z => z.profroma === profroma ? Object.assign({}, z, { 'bonoMonto': z.bonoMonto.filter(bono => bono.id !== id) }) : z) });
      let obj=this.state.listaBonos.filter(z => z.profroma === profroma)[0].bonoMonto.filter(bono => bono.id === id)[0];
      this.setState({totalMontoBonoProforma:this.state.totalMontoBonoProforma-obj.monto*obj.value});
    }else{
      this.setState({ listaBonosAll: this.state.listaBonosAll.map(entry =>  entry.codFiveBono === codFiveBono ? Object.assign({}, entry, { 'bonoMonto': entry.bonoMonto.filter(bono => bono.id !== id) ,totalMontoBonoProforma:entry.totalMontoBonoProforma-entry.bonoMonto.find(bono => bono.id === id).value*entry.bonoMonto.find(bono => bono.id === id).monto}):entry )  });
    }

  }

  onChangeInputs = (e,id,profroma,codFiveBono) =>{
    if(!(/($[0-9,]+(.[0-9]{2})?)/g.test(e.target.value))){
      if(codFiveBono===undefined){
        if(e.target.name==='monto') {
          this.setState({ listaBonos: this.state.listaBonos.map(z => z.profroma === profroma ? Object.assign({}, z, { 'bonoMonto': z.bonoMonto.map(bono => bono.id === id ? Object.assign(bono, { 'monto': e.target.value }) : bono) }) : z) });
        } else if(e.target.name==='cantidad') {
          this.setState({ listaBonos: this.state.listaBonos.map(z => z.profroma === profroma ? Object.assign({}, z, { 'bonoMonto': z.bonoMonto.map(bono => bono.id === id ? Object.assign(bono, { 'value': e.target.value }) : bono) }) : z) });
        }
        this.returnSumaTotal();
      }else{
        let listaBonosAll;
        if(e.target.name==='monto') {
          listaBonosAll = this.state.listaBonosAll.map(entry => entry.codFiveBono===codFiveBono?Object.assign({}, entry, { 'bonoMonto': entry.bonoMonto.map(bono => bono.id === id ? Object.assign(bono, { 'monto': e.target.value })  : bono) }):entry);
        } else if(e.target.name==='cantidad') {
          listaBonosAll = this.state.listaBonosAll.map(entry => entry.codFiveBono===codFiveBono?Object.assign({}, entry, { 'bonoMonto': entry.bonoMonto.map(bono => bono.id === id ? Object.assign(bono, { 'value': e.target.value })  : bono) }):entry);
        }
        this.onChangeMontoListaBonosAll(profroma,codFiveBono,listaBonosAll);
      }
    }else{
      return;
    }

  }

  onChangeMontoListaBonosAll = (profroma,codFiveBono,listaBonosAll) => {

    let suma = 0;
    let objFiveBono = this.state.listaBonosAll.find(entry => entry.codFiveBono===codFiveBono);
    this.getCliente(profroma,codFiveBono).bonoMonto.forEach(element => {
      suma = suma + (element.value * element.monto);
    });

    listaBonosAll = listaBonosAll.map(entry => entry.codFiveBono===codFiveBono?Object.assign({},entry,{totalMontoBonoProforma:suma}):entry)
    let mountToBeCompared = this.props.flagBonos==='AgregarCortesia'? objFiveBono.montoBonoProforma:objFiveBono.montoBonoProforma*this.state.listaPedidosSeleccionados.length;

    console.log('mountToBeCompared',mountToBeCompared);

    if(suma > mountToBeCompared){
      this.setState({alertSuccessOpen:true})
      listaBonosAll = listaBonosAll.map(entry => entry.codFiveBono===codFiveBono?Object.assign({},entry,{status:0}):entry)
    }else{
      this.setState({alertSuccessOpen:false})
      listaBonosAll = listaBonosAll.map(entry => entry.codFiveBono===codFiveBono?Object.assign({},entry,{status:1}):entry)
    }

    this.setState({listaBonosAll:listaBonosAll});

  }

  onChangeSelectBox = (e,id,profroma,codFiveBono) =>{
    if(codFiveBono===undefined){
      this.setState({ listaBonos: this.state.listaBonos.map(z => z.profroma === profroma ? Object.assign({}, z, { 'bonoMonto': z.bonoMonto.map(bono => bono.id === id ? Object.assign(bono, { 'value': e.target.value }) : bono) }) : z) });
      this.returnSumaTotal();
    }else{
      let listaBonosAll = this.state.listaBonosAll.map(entry => entry.codFiveBono===codFiveBono?Object.assign({}, entry, { 'bonoMonto': entry.bonoMonto.map(bono => bono.id === id ? Object.assign(bono, { 'value': e.target.value })  : bono) }):entry);
      this.onChangeMontoListaBonosAll(profroma,codFiveBono,listaBonosAll);
    }

  }

  returnSumaTotal = () =>{
    let suma = 0;
    this.getCliente(this.props.profroma).bonoMonto.forEach(element => {
      suma = suma + (element.value * element.monto);
    });

    this.setState({totalMontoBonoProforma:suma});

    let mountToBeCompared = this.props.flagBonos==='AgregarCortesia'? this.state.montoBonoProforma:this.state.montoBonoProforma*this.state.listaPedidosSeleccionados.length;

    if(suma > mountToBeCompared){
      this.setState({alertSuccessOpen:true})
    }else{
      this.setState({alertSuccessOpen:false})
    }

  }


  onChangebonoObservaciones =(e) =>{
    this.setState({bonoObservaciones: e.target.value});
  }

  closeAlertSuccess = () =>{
    this.setState({alertSuccessOpen:false,alertSuccessOpenBono:false});
  }

  closeModal = () => {
    this.initializeVarables();
    this.props.closeModal();
  }


  render() {
    const { step } = this.state;
    const stepsTitle = ['Definir pedidos', 'Gestionar bono', 'Confirmar'];
    let newArraylistaPedidosSeleccionados=[];
    if(this.props.flagActionTab === 'dropdown'){

      newArraylistaPedidosSeleccionados = this.state.arrayAsignarBonos;
    }else{
      if(this.props.pedidosToEdit.length > 0 ){
          newArraylistaPedidosSeleccionados = this.props.pedidosToEdit

      }else{
        newArraylistaPedidosSeleccionados = this.state.listaPedidosSeleccionados;
      }

    }



    return (
      <div>

      <Modal title={this.props.flagBonos==='AgregarBonos'?'Agregar Bonos':'Agregar Cortesia'} idModal='agregar-bonos' isOpen={this.props.isOpen} closeModal={this.closeModal} modalSize='modal-lg'>
        <div className='modalBleed'>
          <Steps stepsTitle={stepsTitle} step={step} />
        </div>
        <div className='fdvEquip-slides'>
          {
            step === 1 &&
            <FirstStep
              nextStep={this.nextStep}
              pedidos={this.state.listaPedido}
              addPedidosAsignarBonos = {this.props.addPedidosAsignarBonos}
              arrayAsignarBonos={newArraylistaPedidosSeleccionados}
              removeItems={this.removeItems}
              removeCheckItems = {this.removeCheckItems}
              fdvID={this.props.fdvID}
              profroma={this.props.profroma}
              colaboradoresSeleccionados={this.state.colaboradoresSeleccionados}
              flagBonos ={this.props.flagBonos}
              registrarBonos={this.props.registrarBonos}
              renderLoad = {this.props.renderLoad}
              flagActionTab = {this.props.flagActionTab}
              nexCortesia = {this.nexCortesia}
              nexBonos = {this.nexBonos}
              listaPedidosXProforma = {this.props.listaPedidosXProforma}
              pedidosToEdit = {this.props.pedidosToEdit}
              listaBonosXproforma = {this.props.listaBonosXproforma.filter(entry => entry.codEstaVale==='R' || entry.codEstaVale==='I').map(entry => {return entry.codFiveBono})}
              listaBonosXproformaEstados = {this.props.listaBonosXproformaEstados}
            />
          }
          {
            step === 2 &&
            <SecondStep
              nextStep={this.nextStep}
              previousStep={this.previousStep}
              arrayAsignarBonos={newArraylistaPedidosSeleccionados}
              listaItemsBonos={this.state.listaItemsBonos}
              addItemsBonos={this.addItemsBonos}
              removeBono = {this.removeBono}
              onChangeInputs = {this.onChangeInputs}
              onChangeSelectBox = {this.onChangeSelectBox}
              getCliente = {this.getCliente}
              bonoObservaciones = {this.state.bonoObservaciones}
              bonoProforma = {this.state.bonoProforma}
              bonoCortesia = {this.state.bonoCortesia}
              fdvID={this.props.fdvID}
              profroma={this.props.profroma}
              colaboradoresSeleccionados={this.state.colaboradoresSeleccionados}
              flagBonos ={this.props.flagBonos}
              registrarBonos={this.props.registrarBonos}
              renderLoad = {this.props.renderLoad}
              montoBonoProforma = {this.state.montoBonoProforma}
              totalMontoBonoProforma = {this.state.totalMontoBonoProforma}
              onChangeMontoCortesia = {this.onChangeMontoCortesia}
              flagActionTab = {this.props.flagActionTab}
              pedidosToEdit = {this.props.pedidosToEdit}
              listaPedidosXProforma = {this.props.listaPedidosXProforma}

              listaPedidosXCortesia={this.props.listaPedidosXCortesia!==undefined?[ ...new Set(this.props.listaPedidosXCortesia.filter(entry => this.props.pedidosToEdit.indexOf(entry.numPedidoVeh)>=0).map(entry => {return entry.codFiveBono}))]:undefined}
              listaPedidosXCortesiaPedido={this.props.listaPedidosXCortesia}
              pedidosNuevos={this.props.listaPedidosXCortesia!==undefined?this.props.pedidosToEdit.filter(entry => !this.props.listaPedidosXCortesia.map(entry => {return entry.numPedidoVeh}).indexOf(entry)>=0):undefined}
              listaBonosAll = {this.state.listaBonosAll}
              /*Inicio Req. 92293 ebarboza 26 07 2021*/
              codMonedaBono = {this.state.codMonedaBono}
              /*Fin Req. 92293 ebarboza 26 07 2021 */
            />
          }
          {
            step === 3 &&
            <ThirdStep
              previousStep={this.previousStep}
              colaboradoresSeleccionados={this.state.colaboradoresSeleccionados}
              changeColaborador={this.changeColaborador}
              selectColaborador={this.selectColaborador}
              colaborador={this.state.colaborador}
              colaboradores={this.props.colaboradores}
              muestraLoad={this.state.muestraLoad}
              getCliente = {this.getCliente}
              bonoObservaciones = {this.state.bonoObservaciones}
              onChangebonoObservaciones = {this.onChangebonoObservaciones}
              bonoProforma = {this.state.bonoProforma}
              bonoCortesia = {this.state.bonoCortesia}
              arrayAsignarBonos={newArraylistaPedidosSeleccionados}
              onClicRegistrarProforma = {this.onClicRegistrarProforma}
              fdvID={this.props.fdvID}
              profroma={this.props.profroma}
              pedidos={this.state.listaPedido}
              flagBonos ={this.props.flagBonos}
              registrarBonos={this.props.registrarBonos}
              renderLoad = {this.props.renderLoad}
              totalMontoBonoProforma = {this.state.totalMontoBonoProforma}
              flagActionTab = {this.props.flagActionTab}
              pedidosToEdit = {this.props.pedidosToEdit}
              listaPedidosXCortesia={this.props.listaPedidosXCortesia!==undefined?[ ...new Set(this.props.listaPedidosXCortesia.filter(entry => this.props.pedidosToEdit.indexOf(entry.numPedidoVeh)>=0).map(entry => {return entry.codFiveBono}))]:undefined}
              listaPedidosXCortesiaPedido={this.props.listaPedidosXCortesia}
              pedidosNuevos={this.props.listaPedidosXCortesia!==undefined?this.props.pedidosToEdit.filter(entry => !this.props.listaPedidosXCortesia.map(entry => {return entry.numPedidoVeh}).indexOf(entry)>=0):undefined}
              listaBonosAll = {this.state.listaBonosAll}
              removeColaborador = {this.removeColaborador}
              /*Inicio Req. 92293 ebarboza 26 07 2021*/
              codMonedaBono = {this.state.codMonedaBono}
              /*Fin Req. 92293 ebarboza 26 07 2021 */
            />
          }
        </div>

        <div className='modal extraFilter' role='dialog' data-backdrop='static' style={{ zIndex: '2000', display: this.state.muestraLoad }} >
          <div className='modal-dialog modal-sm' role='document'>
            <FadeLoader color={'#F8A14A'} loading />
          </div>
        </div>

      </Modal>
        {
                this.state.alertSuccessOpen &&
                <Alert type='alert-success alertModal' icon='ion-checkmark-circled' closeAlert={this.closeAlertSuccess} >
                <p>El monto total del vale no debe ser mayor al monto del bono </p>
                </Alert>
        }
        {
                this.state.alertSuccessOpenBono &&
                <Alert type='alert-success alertModal' icon='ion-checkmark-circled' closeAlert={this.closeAlertSuccess} >
                <p>La Proforma {this.props.profroma} no tiene un Bono</p>
                </Alert>
        }
        {
          this.props.colaboradores && this.props.colaboradores.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar facturacion</p>
            </Alert> : null
        }

          </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    colaboradores : state.colaboradores,
  };
}

export default connect(
  mapStateToProps,
  {clearColaboradores,fetchColaboradores})(AgregarBonos);



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Bonos/AgregarBonos/index.js